import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }) {
    return (
        <>
            <Header />

            <section className="position-relative-none">
                <div className="content content_wrap">
                    <div className="container-lg">
                        {children}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}
